// import { useState, useEffect, useCallback } from "react";
// import axiosClient from "../axiosClient";
// import {
//   PieChart,
//   Pie,
//   Cell,
//   Legend,
//   Bar,
//   BarChart,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
// } from "recharts";
// import { useStateContext } from "../context/ContextProvider";
// import { useTranslation } from "react-i18next";
// import {
//   Box,
//   Typography,
//   Grid,
//   TextField,
//   Paper,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Button
// } from "@mui/material";

// const COLORS = ["#00C49F", "#FFBB28"]; // Colors for Male and Female

// const RADIAN = Math.PI / 180;
// const renderCustomizedLabel = ({
//   cx,
//   cy,
//   midAngle,
//   innerRadius,
//   outerRadius,
//   value,
// }) => {
//   const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
//   const x = cx + radius * Math.cos(-midAngle * RADIAN);
//   const y = cy + radius * Math.sin(-midAngle * RADIAN);

//   return (
//     <text
//       x={x}
//       y={y}
//       fill="white"
//       textAnchor={x > cx ? "start" : "end"}
//       dominantBaseline="central"
//     >
//       {value}
//     </text>
//   );
// };

// const Statistics = () => {
//   const [genderData, setGenderData] = useState([]);
//   const [ageData, setAgeData] = useState([]);
//   const [smsData, setSmsData] = useState([]);
//   const [genderMonth, setGenderMonth] = useState("");
//   const [genderYear, setGenderYear] = useState("");
//   const [genderWeek, setGenderWeek] = useState("");
//   const [ageMonth, setAgeMonth] = useState("");
//   const [ageYear, setAgeYear] = useState("");
//   const [ageWeek, setAgeWeek] = useState("");
//   const [smsMonth, setSmsMonth] = useState("");
//   const [smsYear, setSmsYear] = useState("");
//   const [smsWeek, setSmsWeek] = useState("");
//   const [statistics, setStatistics] = useState("GENDER");
//   const [yearError, setYearError] = useState(""); // State for year validation error

//   const { user } = useStateContext();
//   const { t } = useTranslation();

//   const statisticsChoices = [
//     { label: t("Gender"), value: "GENDER" },
//     { label: t("Age"), value: "AGE" },
//     { label: t("SMS"), value: "SMS" },
//   ];

//   // Helper function to get the Monday of the selected week
//   const getMondayOfWeek = (dateString) => {
//     const date = new Date(dateString);
//     const day = date.getDay(); // 0 (Sunday) to 6 (Saturday)
//     const diff = day === 0 ? -6 : -day + 1; // Adjust to previous Monday
//     date.setDate(date.getDate() + diff);
//     return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
//   };

//   const validateYear = useCallback((year) => {
//     if (!year) return true;
//     const yearNum = parseInt(year, 10);
//     if (isNaN(yearNum) || yearNum < 2000 || yearNum > 2100) {
//       setYearError(t("Year must be between 2000 and 2100"));
//       return false;
//     }
//     setYearError("");
//     return true;
//   }, [t]);


//   // Clear all filters
//   const handleClearFilters = () => {
//     setGenderMonth("");
//     setGenderYear("");
//     setGenderWeek("");
//     setAgeMonth("");
//     setAgeYear("");
//     setAgeWeek("");
//     setSmsMonth("");
//     setSmsYear("");
//     setSmsWeek("");
//     setStatistics("GENDER");
//     setYearError("");
//     setGenderData([]);
//     setAgeData([]);
//     setSmsData([]);
//   };

//   const fetchGenderData = useCallback(
//     (url) => {
//       axiosClient
//         .get(url, {
//           headers: {
//             Authorization: `Bearer ${user.token}`,
//           },
//         })
//         .then((response) => {
//           console.log(response.data);
//           const { male, female } = response.data;
//           setGenderData([
//             { name: "Male", value: male },
//             { name: "Female", value: female },
//           ]);
//         })
//         .catch((error) => {
//           console.error("Error fetching gender data:", error);
//           setGenderData([]);
//         });
//     },
//     [user.token]
//   );

//   const fetchAgeData = useCallback(
//     (url) => {
//       axiosClient
//         .get(url, {
//           headers: {
//             Authorization: `Bearer ${user.token}`,
//           },
//         })
//         .then((response) => {
//           const ageDistribution = response.data.age_distribution;
//           const ageDataArray = Object.keys(ageDistribution).map((ageRange) => ({
//             name: ageRange,
//             value: ageDistribution[ageRange],
//           }));
//           setAgeData(ageDataArray);
//         })
//         .catch((error) => {
//           console.error("Error fetching age data:", error);
//           setAgeData([]);
//         });
//     },
//     [user.token]
//   );

//   const fetchSmsData = useCallback(
//     (url) => {
//       axiosClient
//         .get(url, {
//           headers: {
//             Authorization: `Bearer ${user.token}`,
//           },
//         })
//         .then((response) => {
//           const formattedData = response.data.map((item) => ({
//             name: item.period,
//             value: item.sends_count,
//           }));
//           setSmsData(formattedData);
//         })
//         .catch((error) => {
//           console.error("Error fetching SMS data:", error);
//           setSmsData([]);
//         });
//     },
//     [user.token]
//   );

//   useEffect(() => {
//     if (genderMonth) {
//       const [year, mon] = genderMonth.split("-");
//       fetchGenderData(`api/clientStats/month/${mon}-${year}/`);
//     }
//   }, [genderMonth, fetchGenderData]);

//   useEffect(() => {
//     if (genderYear && validateYear(genderYear)) {
//       fetchGenderData(`api/clientStats/year/${genderYear}/`);
//     }
//   }, [genderYear, fetchGenderData, validateYear]);

//   useEffect(() => {
//     if (genderWeek) {
//       fetchGenderData(`api/clientStats/week/${genderWeek}/`);
//     }
//   }, [genderWeek, fetchGenderData]);

//   useEffect(() => {
//     if (ageMonth) {
//       const [year, mon] = ageMonth.split("-");
//       fetchAgeData(`api/clientAgeStats/month/${mon}-${year}/`);
//     }
//   }, [ageMonth, fetchAgeData]);

//   useEffect(() => {
//     if (ageYear && validateYear(ageYear)) {
//       fetchAgeData(`api/clientAgeStats/year/${ageYear}/`);
//     }
//   }, [ageYear, fetchAgeData, validateYear]);

//   useEffect(() => {
//     if (ageWeek) {
//       fetchAgeData(`api/clientAgeStats/week/${ageWeek}/`);
//     }
//   }, [ageWeek, fetchAgeData]);

//   useEffect(() => {
//     if (smsMonth) {
//       const [year, mon] = smsMonth.split("-");
//       fetchSmsData(`api/appointment-send-info/stats/?year=${year}&month=${mon}`);
//     }
//   }, [smsMonth, fetchSmsData]);

//   useEffect(() => {
//     if (smsYear && validateYear(smsYear)) {
//       fetchSmsData(`api/appointment-send-info/stats/?year=${smsYear}`);
//     }
//   }, [smsYear, fetchSmsData, validateYear]);

//   useEffect(() => {
//     if (smsWeek) {
//       const [year, week] = smsWeek.split("-");
//       fetchSmsData(`api/appointment-send-info/stats/?year=${year}&week=${week}`);
//     }
//   }, [smsWeek, fetchSmsData]);

//   const handleGenderWeekChange = (e) => {
//     const selectedDate = e.target.value;
//     if (selectedDate) {
//       const mondayDate = getMondayOfWeek(selectedDate);
//       setGenderWeek(mondayDate);
//     } else {
//       setGenderWeek("");
//     }
//     setGenderMonth("");
//     setGenderYear("");
//   };

//   const handleAgeWeekChange = (e) => {
//     const selectedDate = e.target.value;
//     if (selectedDate) {
//       const mondayDate = getMondayOfWeek(selectedDate);
//       setAgeWeek(mondayDate);
//     } else {
//       setAgeWeek("");
//     }
//     setAgeMonth("");
//     setAgeYear("");
//   };

//   const handleSmsWeekChange = (e) => {
//     const selectedDate = e.target.value;
//     if (selectedDate) {
//       const mondayDate = getMondayOfWeek(selectedDate);
//       setSmsWeek(mondayDate);
//     } else {
//       setSmsWeek("");
//     }
//     setSmsMonth("");
//     setSmsYear("");
//   };

//   const handleYearChange = (e, type) => {
//     const value = e.target.value;
//     if (type === "GENDER") {
//       setGenderYear(value);
//       setGenderMonth("");
//       setGenderWeek("");
//     } else if (type === "AGE") {
//       setAgeYear(value);
//       setAgeMonth("");
//       setAgeWeek("");
//     } else {
//       setSmsYear(value);
//       setSmsMonth("");
//       setSmsWeek("");
//     }
//     validateYear(value);
//   };

//   return (
//     <Box sx={{ p: { xs: 2, md: 4 } }}>
//       {/* Inform users about Monday requirement */}
//       <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
//         {t(
//           "Note: For weekly stats, please select a Monday. The system will automatically adjust to the Monday of the selected week."
//         )}
//       </Typography>

//       {/* Input Fields */}
//       <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
//         <Grid container spacing={3}>
//           <Grid item xs={12} md={4}>
//             <Typography variant="h6" gutterBottom>
//               {t("Select Statistic Type")}
//             </Typography>
//             <FormControl fullWidth variant="outlined">
//               <InputLabel>{t("Statistics")}</InputLabel>
//               <Select
//                 value={statistics}
//                 onChange={(e) => setStatistics(e.target.value)}
//                 label={t("Statistics")}
//               >
//                 {statisticsChoices.map((stats, idx) => (
//                   <MenuItem key={idx} value={stats.value}>
//                     {stats.label}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>
//           <Grid item xs={12} md={4}>
//             <Typography variant="h6" gutterBottom>
//               {t("Stats by Month")}
//             </Typography>
//             <TextField
//               type="month"
//               value={
//                 statistics === "GENDER"
//                   ? genderMonth
//                   : statistics === "AGE"
//                     ? ageMonth
//                     : smsMonth
//               }
//               onChange={(e) => {
//                 if (statistics === "GENDER") {
//                   setGenderMonth(e.target.value);
//                   setGenderYear("");
//                   setGenderWeek("");
//                 } else if (statistics === "AGE") {
//                   setAgeMonth(e.target.value);
//                   setAgeYear("");
//                   setAgeWeek("");
//                 } else {
//                   setSmsMonth(e.target.value);
//                   setSmsYear("");
//                   setSmsWeek("");
//                 }
//               }}
//               fullWidth
//               variant="outlined"
//               InputLabelProps={{ shrink: true }}
//             />
//           </Grid>
//           <Grid item xs={12} md={4}>
//             <Typography variant="h6" gutterBottom>
//               {t("Stats by Year")}
//             </Typography>
//             <TextField
//               type="number"
//               value={
//                 statistics === "GENDER"
//                   ? genderYear
//                   : statistics === "AGE"
//                     ? ageYear
//                     : smsYear
//               }
//               onChange={(e) => handleYearChange(e, statistics)}
//               fullWidth
//               variant="outlined"
//               InputProps={{
//                 inputProps: { min: 2000, max: 2100 },
//               }}
//               InputLabelProps={{ shrink: true }}
//               error={!!yearError}
//               helperText={yearError}
//             />
//           </Grid>
//           <Grid item xs={12} md={4}>
//             <Typography variant="h6" gutterBottom>
//               {t("Stats by Week")}
//             </Typography>
//             <TextField
//               type="date"
//               value={
//                 statistics === "GENDER"
//                   ? genderWeek
//                   : statistics === "AGE"
//                     ? ageWeek
//                     : smsWeek
//               }
//               onChange={
//                 statistics === "GENDER"
//                   ? handleGenderWeekChange
//                   : statistics === "AGE"
//                     ? handleAgeWeekChange
//                     : handleSmsWeekChange
//               }
//               fullWidth
//               variant="outlined"
//               InputLabelProps={{ shrink: true }}
//             />
//           </Grid>
//           <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
//             <Button
//               variant="outlined"
//               color="secondary"
//               onClick={handleClearFilters}
//               sx={{ mt: 2 }}
//             >
//               {t("Clear Filters")}
//             </Button>
//           </Grid>
//         </Grid>
//       </Paper>

//       {/* Charts */}
//       <Paper elevation={3} sx={{ p: 3 }}>
//         {statistics === "GENDER" && (
//           <>
//             <Typography variant="h6" gutterBottom>
//               {t("Gender Statistic")}
//             </Typography>
//             {genderData.length > 0 ? (
//               <PieChart width={800} height={400}>
//                 <Legend
//                   height={36}
//                   iconType="circle"
//                   layout="vertical"
//                   verticalAlign="middle"
//                   iconSize={10}
//                   padding={5}
//                 />
//                 <Pie
//                   data={genderData}
//                   cx="50%"
//                   cy="50%"
//                   labelLine={false}
//                   label={renderCustomizedLabel}
//                   outerRadius={150}
//                   paddingAngle={0}
//                   fill="#8884d8"
//                   dataKey="value"
//                 >
//                   {genderData.map((entry, index) => (
//                     <Cell
//                       key={`cell-${index}`}
//                       fill={COLORS[index % COLORS.length]}
//                     />
//                   ))}
//                 </Pie>
//                 <Tooltip />
//               </PieChart>
//             ) : (
//               <Typography>
//                 {t("No data available for the selected period")}.
//               </Typography>
//             )}
//           </>
//         )}
//         {statistics === "AGE" && (
//           <>
//             <Typography variant="h6" gutterBottom>
//               {t("Age Statistic")}
//             </Typography>
//             {ageData.length > 0 ? (
//               <BarChart
//                 width={800}
//                 height={400}
//                 data={ageData}
//                 margin={{
//                   top: 5,
//                   right: 30,
//                   left: 20,
//                   bottom: 5,
//                 }}
//               >
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="name" />
//                 <YAxis />
//                 <Tooltip />
//                 <Legend />
//                 <Bar dataKey="value" fill="#8884d8" barSize={50} />
//               </BarChart>
//             ) : (
//               <Typography>
//                 {t("No data available for the selected period")}.
//               </Typography>
//             )}
//           </>
//         )}
//         {statistics === "SMS" && (
//           <>
//             <Typography variant="h6" gutterBottom>
//               {t("SMS Statistic")}
//             </Typography>
//             {smsData.length > 0 ? (
//               <BarChart
//                 width={800}
//                 height={400}
//                 data={smsData}
//                 margin={{
//                   top: 5,
//                   right: 30,
//                   left: 20,
//                   bottom: 5,
//                 }}
//               >
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="name" />
//                 <YAxis />
//                 <Tooltip />
//                 <Legend />
//                 <Bar dataKey="value" fill="#8884d8" barSize={50} />
//               </BarChart>
//             ) : (
//               <Typography>
//                 {t("No data available for the selected period")}.
//               </Typography>
//             )}
//           </>
//         )}
//       </Paper>
//     </Box>
//   );
// };

// export default Statistics;


import { useState, useEffect, useCallback } from "react";
import axiosClient from "../axiosClient";
import {
  PieChart,
  Pie,
  Cell,
  Legend,
  Bar,
  BarChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import { useStateContext } from "../context/ContextProvider";
import { useTranslation } from "react-i18next";
import {
  Box,
  Typography,
  Grid,
  TextField,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from "@mui/material";

const COLORS = ["#00C49F", "#FFBB28"]; // Colors for Male and Female

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  value,
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
    >
      {value}
    </text>
  );
};

const Statistics = () => {
  const [genderData, setGenderData] = useState([]);
  const [ageData, setAgeData] = useState([]);
  const [smsData, setSmsData] = useState([]);
  const [genderMonth, setGenderMonth] = useState("");
  const [genderYear, setGenderYear] = useState("");
  const [genderWeek, setGenderWeek] = useState("");
  const [ageMonth, setAgeMonth] = useState("");
  const [ageYear, setAgeYear] = useState("");
  const [ageWeek, setAgeWeek] = useState("");
  const [smsMonth, setSmsMonth] = useState("");
  const [smsYear, setSmsYear] = useState("");
  const [smsWeek, setSmsWeek] = useState("");
  const [statistics, setStatistics] = useState("GENDER");
  const [yearError, setYearError] = useState("");

  const { user } = useStateContext();
  const { t } = useTranslation();

  const statisticsChoices = [
    { label: t("clientStats.gender"), value: "GENDER" },
    { label: t("clientStats.age"), value: "AGE" },
    { label: t("clientStats.sms"), value: "SMS" },
  ];

  // Helper function to get the Monday of the selected week
  const getMondayOfWeek = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDay(); // 0 (Sunday) to 6 (Saturday)
    const diff = day === 0 ? -6 : -day + 1; // Adjust to previous Monday
    date.setDate(date.getDate() + diff);
    return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };

  const validateYear = useCallback(
    (year) => {
      if (!year) return true;
      const yearNum = parseInt(year, 10);
      if (isNaN(yearNum) || yearNum < 2000 || yearNum > 2100) {
        setYearError(t("reports.yearValidationError"));
        return false;
      }
      setYearError("");
      return true;
    },
    [t]
  );

  // Clear all filters
  const handleClearFilters = () => {
    setGenderMonth("");
    setGenderYear("");
    setGenderWeek("");
    setAgeMonth("");
    setAgeYear("");
    setAgeWeek("");
    setSmsMonth("");
    setSmsYear("");
    setSmsWeek("");
    setStatistics("GENDER");
    setYearError("");
    setGenderData([]);
    setAgeData([]);
    setSmsData([]);
  };

  const fetchGenderData = useCallback(
    (url) => {
      axiosClient
        .get(url, {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        })
        .then((response) => {
          const { male, female } = response.data;
          setGenderData([
            { name: t("clientStats.male"), value: male },
            { name: t("clientStats.female"), value: female },
          ]);
        })
        .catch((error) => {
          console.error("Error fetching gender data:", error);
          setGenderData([]);
        });
    },
    [user.token, t]
  );

  const fetchAgeData = useCallback(
    (url) => {
      axiosClient
        .get(url, {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        })
        .then((response) => {
          const ageDistribution = response.data.age_distribution;
          const ageDataArray = Object.keys(ageDistribution).map((ageRange) => ({
            name: ageRange,
            value: ageDistribution[ageRange],
          }));
          setAgeData(ageDataArray);
        })
        .catch((error) => {
          console.error("Error fetching age data:", error);
          setAgeData([]);
        });
    },
    [user.token]
  );

  const fetchSmsData = useCallback(
    (url) => {
      axiosClient
        .get(url, {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        })
        .then((response) => {
          const formattedData = response.data.map((item) => ({
            name: item.period,
            value: item.sends_count,
          }));
          setSmsData(formattedData);
        })
        .catch((error) => {
          console.error("Error fetching SMS data:", error);
          setSmsData([]);
        });
    },
    [user.token]
  );

  useEffect(() => {
    if (genderMonth) {
      const [year, mon] = genderMonth.split("-");
      fetchGenderData(`api/clientStats/month/${mon}-${year}/`);
    }
  }, [genderMonth, fetchGenderData]);

  useEffect(() => {
    if (genderYear && validateYear(genderYear)) {
      fetchGenderData(`api/clientStats/year/${genderYear}/`);
    }
  }, [genderYear, fetchGenderData, validateYear]);

  useEffect(() => {
    if (genderWeek) {
      fetchGenderData(`api/clientStats/week/${genderWeek}/`);
    }
  }, [genderWeek, fetchGenderData]);

  useEffect(() => {
    if (ageMonth) {
      const [year, mon] = ageMonth.split("-");
      fetchAgeData(`api/clientAgeStats/month/${mon}-${year}/`);
    }
  }, [ageMonth, fetchAgeData]);

  useEffect(() => {
    if (ageYear && validateYear(ageYear)) {
      fetchAgeData(`api/clientAgeStats/year/${ageYear}/`);
    }
  }, [ageYear, fetchAgeData, validateYear]);

  useEffect(() => {
    if (ageWeek) {
      fetchAgeData(`api/clientAgeStats/week/${ageWeek}/`);
    }
  }, [ageWeek, fetchAgeData]);

  useEffect(() => {
    if (smsMonth) {
      const [year, mon] = smsMonth.split("-");
      fetchSmsData(
        `api/appointment-send-info/stats/?year=${year}&month=${mon}`
      );
    }
  }, [smsMonth, fetchSmsData]);

  useEffect(() => {
    if (smsYear && validateYear(smsYear)) {
      fetchSmsData(`api/appointment-send-info/stats/?year=${smsYear}`);
    }
  }, [smsYear, fetchSmsData, validateYear]);

  useEffect(() => {
    if (smsWeek) {
      const [year, week] = smsWeek.split("-");
      fetchSmsData(
        `api/appointment-send-info/stats/?year=${year}&week=${week}`
      );
    }
  }, [smsWeek, fetchSmsData]);

  const handleGenderWeekChange = (e) => {
    const selectedDate = e.target.value;
    if (selectedDate) {
      const mondayDate = getMondayOfWeek(selectedDate);
      setGenderWeek(mondayDate);
    } else {
      setGenderWeek("");
    }
    setGenderMonth("");
    setGenderYear("");
  };

  const handleAgeWeekChange = (e) => {
    const selectedDate = e.target.value;
    if (selectedDate) {
      const mondayDate = getMondayOfWeek(selectedDate);
      setAgeWeek(mondayDate);
    } else {
      setAgeWeek("");
    }
    setAgeMonth("");
    setAgeYear("");
  };

  const handleSmsWeekChange = (e) => {
    const selectedDate = e.target.value;
    if (selectedDate) {
      const mondayDate = getMondayOfWeek(selectedDate);
      setSmsWeek(mondayDate);
    } else {
      setSmsWeek("");
    }
    setSmsMonth("");
    setSmsYear("");
  };

  const handleYearChange = (e, type) => {
    const value = e.target.value;
    if (type === "GENDER") {
      setGenderYear(value);
      setGenderMonth("");
      setGenderWeek("");
    } else if (type === "AGE") {
      setAgeYear(value);
      setAgeMonth("");
      setAgeWeek("");
    } else {
      setSmsYear(value);
      setSmsMonth("");
      setSmsWeek("");
    }
    validateYear(value);
  };

  return (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
      {/* Weekly note */}
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {t("reports.weekNote")}
      </Typography>

      {/* Filters */}
      <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              {t("clientStats.selectStatisticType")}
            </Typography>
            <FormControl fullWidth variant="outlined">
              <InputLabel>{t("clientStats.statisticsLabel")}</InputLabel>
              <Select
                value={statistics}
                onChange={(e) => setStatistics(e.target.value)}
                label={t("clientStats.statisticsLabel")}
              >
                {statisticsChoices.map((stats, idx) => (
                  <MenuItem key={idx} value={stats.value}>
                    {stats.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              {t("clientStats.statsByMonth")}
            </Typography>
            <TextField
              type="month"
              value={
                statistics === "GENDER"
                  ? genderMonth
                  : statistics === "AGE"
                  ? ageMonth
                  : smsMonth
              }
              onChange={(e) => {
                if (statistics === "GENDER") {
                  setGenderMonth(e.target.value);
                  setGenderYear("");
                  setGenderWeek("");
                } else if (statistics === "AGE") {
                  setAgeMonth(e.target.value);
                  setAgeYear("");
                  setAgeWeek("");
                } else {
                  setSmsMonth(e.target.value);
                  setSmsYear("");
                  setSmsWeek("");
                }
              }}
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              {t("clientStats.statsByYear")}
            </Typography>
            <TextField
              type="number"
              value={
                statistics === "GENDER"
                  ? genderYear
                  : statistics === "AGE"
                  ? ageYear
                  : smsYear
              }
              onChange={(e) => handleYearChange(e, statistics)}
              fullWidth
              variant="outlined"
              InputProps={{
                inputProps: { min: 2000, max: 2100 },
              }}
              InputLabelProps={{ shrink: true }}
              error={!!yearError}
              helperText={yearError}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              {t("clientStats.statsByWeek")}
            </Typography>
            <TextField
              type="date"
              value={
                statistics === "GENDER"
                  ? genderWeek
                  : statistics === "AGE"
                  ? ageWeek
                  : smsWeek
              }
              onChange={
                statistics === "GENDER"
                  ? handleGenderWeekChange
                  : statistics === "AGE"
                  ? handleAgeWeekChange
                  : handleSmsWeekChange
              }
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleClearFilters}
              sx={{ mt: 2 }}
            >
              {t("Clear Filters")}
            </Button>
          </Grid>
        </Grid>
      </Paper>

      {/* Charts */}
      <Paper elevation={3} sx={{ p: 3 }}>
        {statistics === "GENDER" && (
          <>
            <Typography variant="h6" gutterBottom>
              {t("clientStats.genderStatistic")}
            </Typography>
            {genderData.length > 0 ? (
              <PieChart width={800} height={400}>
                <Legend
                  height={36}
                  iconType="circle"
                  layout="vertical"
                  verticalAlign="middle"
                  iconSize={10}
                  padding={5}
                />
                <Pie
                  data={genderData}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  label={renderCustomizedLabel}
                  outerRadius={150}
                  paddingAngle={0}
                  fill="#8884d8"
                  dataKey="value"
                >
                  {genderData.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                    />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            ) : (
              <Typography>{t("reports.noDataForPeriod")}</Typography>
            )}
          </>
        )}

        {statistics === "AGE" && (
          <>
            <Typography variant="h6" gutterBottom>
              {t("clientStats.ageStatistic")}
            </Typography>
            {ageData.length > 0 ? (
              <BarChart
                width={800}
                height={400}
                data={ageData}
                margin={{
                  top: 5,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="value" fill="#8884d8" barSize={50} />
              </BarChart>
            ) : (
              <Typography>{t("reports.noDataForPeriod")}</Typography>
            )}
          </>
        )}

        {statistics === "SMS" && (
          <>
            <Typography variant="h6" gutterBottom>
              {t("clientStats.smsStatistic")}
            </Typography>
            {smsData.length > 0 ? (
              <BarChart
                width={800}
                height={400}
                data={smsData}
                margin={{
                  top: 5,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="value" fill="#8884d8" barSize={50} />
              </BarChart>
            ) : (
              <Typography>{t("reports.noDataForPeriod")}</Typography>
            )}
          </>
        )}
      </Paper>
    </Box>
  );
};

export default Statistics;
